// Rule-simulator model, ported verbatim from the design's DATA array and renderVals():
// a request is immediately quotable when its guest count is strictly below the
// review threshold; the slider track fill maps the 20..120 range onto 0..100%.

export interface SimRequest {
  ev: string;
  type: string;
  g: number;
}

export const SIM_DATA: readonly SimRequest[] = [
  { ev: "Geburtstag im Garten", type: "Fingerfood", g: 25 },
  { ev: "Sommerfest", type: "BBQ", g: 35 },
  { ev: "Firmenjubiläum", type: "Buffet", g: 45 },
  { ev: "Produktlaunch", type: "Flying Buffet", g: 65 },
  { ev: "Hochzeit", type: "Menü", g: 90 },
  { ev: "Messestand, 3 Tage", type: "Fingerfood", g: 110 },
];

export const SIM_THRESHOLD_DEFAULT = 60;
export const SIM_THRESHOLD_MIN = 20;
export const SIM_THRESHOLD_MAX = 120;
export const SIM_THRESHOLD_STEP = 5;

export function isQuotable(guestCount: number, threshold: number): boolean {
  return guestCount < threshold;
}

export function autoCount(data: readonly SimRequest[], threshold: number): number {
  return data.filter((row) => isQuotable(row.g, threshold)).length;
}

export function sliderPct(threshold: number): number {
  return ((threshold - SIM_THRESHOLD_MIN) / 100) * 100;
}
